var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/customers/list" } } },
                [_c("div", { staticClass: "div2" }, [_vm._v("我的客户")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.show3,
              expression: "!show3",
            },
          ],
          staticClass: "query",
        },
        [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "polling" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "search-form",
                  attrs: {
                    inline: true,
                    model: _vm.queryForm,
                    "label-width": "",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择客户类型",
                            clearable: "",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleSelectClientType },
                          model: {
                            value: _vm.queryForm.clientType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "clientType", $$v)
                            },
                            expression: "queryForm.clientType",
                          },
                        },
                        _vm._l(_vm.client, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客户姓名",
                          maxlength: 12,
                          minlength: 1,
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent()
                          },
                        },
                        model: {
                          value: _vm.queryForm.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客户手机号码",
                          maxLength: 16,
                          oninput:
                            "if (value.length > 16) value = value.slice(0, 16);",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent()
                          },
                        },
                        model: {
                          value: _vm.queryForm.phone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "phone",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户等级" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择客户等级",
                            clearable: "",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleSelectCategory },
                          model: {
                            value: _vm.queryForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "category", $$v)
                            },
                            expression: "queryForm.category",
                          },
                        },
                        _vm._l(_vm.rank, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "部门选择" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          props: {
                            checkStrictly: true,
                            label: "orgName",
                            value: "orgCode",
                            children: "children",
                          },
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.handleSelectOrgName },
                        model: {
                          value: _vm.queryForm.orgName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "orgName", $$v)
                          },
                          expression: "queryForm.orgName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "跟进客服" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择客服",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleSelectCustomer },
                          model: {
                            value: _vm.queryForm.service,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "service", $$v)
                            },
                            expression: "queryForm.service",
                          },
                        },
                        _vm._l(_vm.customer, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.reallyName, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道号" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "选择渠道号",
                            clearable: "",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleSelectIncoming },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent()
                            },
                          },
                          model: {
                            value: _vm.queryForm.Incoming,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "Incoming", $$v)
                            },
                            expression: "queryForm.Incoming",
                          },
                        },
                        _vm._l(_vm.line, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.name, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "来源平台" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "选择来源平台",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryForm.platformId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "platformId", $$v)
                            },
                            expression: "queryForm.platformId",
                          },
                        },
                        _vm._l(_vm.platformList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: {
                          input: _vm.immediUpdate,
                          change: _vm.handleSelectDate,
                        },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分配时间" } },
                    [
                      _c(
                        "el-date-picker",
                        {
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            clearable: "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.assignTime,
                            callback: function ($$v) {
                              _vm.assignTime = $$v
                            },
                            expression: "assignTime",
                          },
                        },
                        [_vm._v(" > ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "指派时间" } },
                    [
                      _c(
                        "el-date-picker",
                        {
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            clearable: "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.customerAssignTime,
                            callback: function ($$v) {
                              _vm.customerAssignTime = $$v
                            },
                            expression: "customerAssignTime",
                          },
                        },
                        [_vm._v(" > ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否外呼" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "选择是否外呼",
                            clearable: "",
                            "default-first-option": false,
                          },
                          on: { change: _vm.handleTracking },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent()
                            },
                          },
                          model: {
                            value: _vm.queryForm.trackingFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "trackingFlag", $$v)
                            },
                            expression: "queryForm.trackingFlag",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "0",
                            attrs: { label: "否", value: 0 },
                          }),
                          _c("el-option", {
                            key: "1",
                            attrs: { label: "是", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "外呼时间" } },
                    [
                      _c(
                        "el-date-picker",
                        {
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            clearable: "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.trackingTime,
                            callback: function ($$v) {
                              _vm.trackingTime = $$v
                            },
                            expression: "trackingTime",
                          },
                        },
                        [_vm._v(" > ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "接听状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "选择接听状态",
                            clearable: "",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleAnswerStatus },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent()
                            },
                          },
                          model: {
                            value: _vm.queryForm.receiveState,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "receiveState", $$v)
                            },
                            expression: "queryForm.receiveState",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "0",
                            attrs: { label: "无", value: 0 },
                          }),
                          _c("el-option", {
                            key: "1",
                            attrs: { label: "接通", value: 1 },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: { label: "未接通", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "接听状况" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择接听状况",
                            clearable: "",
                            disabled: _vm.queryForm.answerState,
                            "default-first-option": true,
                          },
                          model: {
                            value: _vm.queryForm.receiveDetails,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "receiveDetails", $$v)
                            },
                            expression: "queryForm.receiveDetails",
                          },
                        },
                        _vm._l(_vm.answerStateDate.list, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.name, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "选择微信添加状态",
                            clearable: "",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleWxAddState },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent()
                            },
                          },
                          model: {
                            value: _vm.queryForm.wxFencing,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "wxFencing", $$v)
                            },
                            expression: "queryForm.wxFencing",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "0",
                            attrs: { label: "已添加", value: 3 },
                          }),
                          _c("el-option", {
                            key: "1",
                            attrs: { label: "未添加", value: 4 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信状况" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择微信状况",
                            clearable: "",
                            "default-first-option": true,
                          },
                          model: {
                            value: _vm.queryForm.wxDetails,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "wxDetails", $$v)
                            },
                            expression: "queryForm.wxDetails",
                          },
                        },
                        _vm._l(_vm.wxAddStateData.list, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.name, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "地区" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          props: { checkStrictly: true },
                          options: _vm.addressOptions,
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryForm.region1,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "region1", $$v)
                          },
                          expression: "queryForm.region1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客户微信号",
                          clearable: "",
                          maxLength: 20,
                          oninput:
                            "if (value.length > 20) value = value.slice(0, 20);",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent()
                          },
                        },
                        model: {
                          value: _vm.queryForm.wechatNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "wechatNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.wechatNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px", "margin-top": "5px" },
                      attrs: { placeholder: "选择模式", size: "small" },
                      on: { change: _vm.handleSelectModeChange },
                      model: {
                        value: _vm.selectMode,
                        callback: function ($$v) {
                          _vm.selectMode = $$v
                        },
                        expression: "selectMode",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "单选类目", value: "single" },
                      }),
                      _c("el-option", {
                        attrs: { label: "多选类目", value: "multiple" },
                      }),
                    ],
                    1
                  ),
                  _vm.selectMode === "multiple"
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "62px", "margin-top": "5px" },
                          attrs: { size: "small", placeholder: "交并集模式" },
                          on: { change: _vm.handleIntersectionModeChange },
                          model: {
                            value: _vm.queryForm.isAnd,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "isAnd", $$v)
                            },
                            expression: "queryForm.isAnd",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: { label: "且", value: 1 },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: { label: "或", value: 2 },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-right": "-56px" } },
                    [
                      _c("el-cascader", {
                        key: _vm.cascaderKey,
                        attrs: {
                          clearable: "",
                          options: _vm.categoryOptions,
                          props: {
                            multiple: _vm.selectMode === "multiple",
                            label: "categoryName",
                            value: "id",
                            checkStrictly: true,
                            // emitPath: selectMode === 'multiple'
                            emitPath: true,
                          },
                          filterable: "",
                        },
                        on: {
                          change: _vm.handleChangeSearch,
                          "remove-tag": _vm.handleRemoveTag,
                        },
                        model: {
                          value: _vm.queryForm.selectedCategoryPath,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "selectedCategoryPath", $$v)
                          },
                          expression: "queryForm.selectedCategoryPath",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户意向" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            filterable: "",
                            placeholder: "请选择客户意向",
                            clearable: "",
                            "default-first-option": true,
                          },
                          on: { change: _vm.handleSelectIntention },
                          model: {
                            value: _vm.queryForm.buyIntentionList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "buyIntentionList", $$v)
                            },
                            expression: "queryForm.buyIntentionList",
                          },
                        },
                        _vm._l(_vm.intention, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "资源时间" } },
                    [
                      _c(
                        "el-date-picker",
                        {
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            clearable: "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.resourceTime,
                            callback: function ($$v) {
                              _vm.resourceTime = $$v
                            },
                            expression: "resourceTime",
                          },
                        },
                        [_vm._v(" > ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.searchEvent()
                            },
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        { attrs: { plain: "" }, on: { click: _vm.reset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "table" }, [
        _c("div", { staticClass: "inquiryTab" }, [
          _c("div", { staticClass: "inquiryTab_header" }, [
            _c("div", { staticClass: "tabTitle" }, [_vm._v("客户列表")]),
            _c(
              "div",
              { staticClass: "btnBox", staticStyle: { display: "flex" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "totalCount",
                    staticStyle: { display: "flex", "line-height": "36px" },
                  },
                  [
                    _vm._v("(当前列表累计客户"),
                    _c("p", [_vm._v(_vm._s(_vm.tableData.totalNum))]),
                    _vm._v(" 个，累计消费总金额"),
                    _c("p", [
                      _vm._v(
                        "￥" + _vm._s(_vm.totalCount.totalConsumptionAmount)
                      ),
                    ]),
                    _vm._v(")"),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-right": "60px" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#606266",
                          "line-height": "36px",
                        },
                      },
                      [_vm._v("跟进记录浮窗")]
                    ),
                    _c("el-switch", {
                      staticStyle: {
                        "margin-top": "8px",
                        "margin-left": "10px",
                      },
                      on: { change: _vm.handleChangeR },
                      model: {
                        value: _vm.isShow,
                        callback: function ($$v) {
                          _vm.isShow = $$v
                        },
                        expression: "isShow",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _vm.parArray.indexOf("exportKefu") != -1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: { click: _vm.exportKefu },
                          },
                          [_vm._v("导出跟进客服")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.queryService },
                      },
                      [_vm._v("跟进客服查询")]
                    ),
                    _vm.parArray.indexOf("addCustomerCode") != -1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.showDialog("新增客户", "add", "50%")
                              },
                            },
                          },
                          [_vm._v("新增客户")]
                        )
                      : _vm._e(),
                    _vm.parArray.indexOf("assageWy") != -1
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.onDetail()
                              },
                            },
                          },
                          [_vm._v("批量指派")]
                        )
                      : _vm._e(),
                    _vm.parArray.indexOf("userExportCode") != -1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: { click: _vm.customerGuide },
                          },
                          [_vm._v("客户跟进反馈")]
                        )
                      : _vm._e(),
                    _vm.parArray.indexOf("userExportCode") != -1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "warning", size: "mini" },
                            on: { click: _vm.customerMoneySum },
                          },
                          [_vm._v("导出客户消费总额")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "horizontal-scroll",
                      rawName: "v-horizontal-scroll",
                      value: "always",
                      expression: "'always'",
                    },
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "tableCont",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData.list,
                    "header-cell-style": {
                      background: "#fafafa",
                      color: "#333333",
                    },
                    "default-sort": {
                      prop: "updatedTime",
                      order: "descending",
                    },
                  },
                  on: {
                    "selection-change": _vm.handleSelectionChange,
                    "sort-change": _vm.handleSortChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "姓名", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: { cursor: "pointer" },
                                style: scope.row.isFollow
                                  ? "color:#409EFF;font-weight: bold"
                                  : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.toInformation(scope.row, 1)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.userName))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      field: "phone",
                      label: "手机号码",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isShow
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom",
                                      width: "520",
                                      trigger: "hover",
                                    },
                                    on: {
                                      show: function ($event) {
                                        return _vm.getFollow(scope.row.id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "loading",
                                            rawName: "v-loading",
                                            value: _vm.followLoading,
                                            expression: "followLoading",
                                          },
                                        ],
                                      },
                                      [
                                        _vm.customerData.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "show-followUp" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "titleCss" },
                                                  [_vm._v("跟进记录")]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "followUp" },
                                                  _vm._l(
                                                    _vm.customerData,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "followUpBox",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _c("span", [
                                                              _vm._v(
                                                                "跟进人："
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.customerName
                                                                      ? item.customerName
                                                                      : "-"
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]),
                                                          _c("p", [
                                                            _c("span", [
                                                              _vm._v(
                                                                "所属公司部门："
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.companyName
                                                                      ? item.companyName
                                                                      : "-"
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]),
                                                          _c("p", [
                                                            _c("span", [
                                                              _vm._v(
                                                                "跟进情况："
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.comment
                                                                      ? item.comment
                                                                      : "-"
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]),
                                                          _c("p", [
                                                            _c("span", [
                                                              _vm._v(
                                                                "跟进类型："
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.receiveState ==
                                                                      0
                                                                      ? "无"
                                                                      : item.receiveState
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v("/"),
                                                              _c("span", [
                                                                _vm._v(
                                                                  "微信" +
                                                                    _vm._s(
                                                                      item.wxFencing
                                                                    )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]),
                                                          _c("p", [
                                                            _c("span", [
                                                              _vm._v(
                                                                "操作时间："
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.createdTime
                                                                      ? item.createdTime
                                                                      : "-"
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "followUpBox_index",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.numIndex
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c("el-empty", {
                                                  attrs: {
                                                    description: "暂无跟进内容",
                                                    "image-size": 80,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm.is_null(scope.row.phone2)
                                          ? _c(
                                              "div",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyString(
                                                      scope.row.phone
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.phone) + " "
                                                ),
                                              ]
                                            )
                                          : _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyString(
                                                        scope.row.phone
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.phone)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyString(
                                                        scope.row.phone2
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.phone2)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _c(
                                    "div",
                                    { staticStyle: { cursor: "pointer" } },
                                    [
                                      _vm.is_null(scope.row.phone2)
                                        ? _c(
                                            "div",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyString(
                                                    scope.row.phone
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.phone) + " "
                                              ),
                                            ]
                                          )
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyString(
                                                      scope.row.phone
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(scope.row.phone))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyString(
                                                      scope.row.phone2
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(scope.row.phone2))]
                                            ),
                                          ]),
                                    ]
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "微信号", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.is_null(scope.row.wechatNo2)
                              ? _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyString(
                                          scope.row.wechatNo
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.wechatNo
                                          ? scope.row.wechatNo
                                          : "--"
                                      )
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyString(
                                            scope.row.wechatNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.wechatNo))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyString(
                                            scope.row.wechatNo2
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.wechatNo2))]
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label:
                        "客户类目 / 来源平台 / 渠道号 / 等级 / 客服 / 跟进次数",
                      "min-width": "460",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.extantMap,
                            function (item, index) {
                              return _c(
                                "p",
                                { key: index },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.categoryName
                                          ? item.categoryName
                                          : "--"
                                      ) + " / "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.platformName
                                          ? item.platformName
                                          : "--"
                                      ) + " / "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.userDitchName
                                          ? item.userDitchName
                                          : "--"
                                      ) + " / "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.level ? item.level : "--") +
                                        " / "
                                    ),
                                  ]),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "单击复制",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyServiceName(
                                                item.customerName
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.customerName
                                                  ? item.customerName
                                                  : "--"
                                              ) +
                                              " / "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.traceExists
                                          ? item.traceExists
                                          : "--"
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "客户意向", "min-width": "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.extantMap,
                            function (item, index) {
                              return _c("p", { key: index }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.userIntention
                                        ? item.userIntention
                                        : "--"
                                    ) +
                                    " "
                                ),
                              ])
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      field: "address",
                      label: "地区",
                      "show-overflow": "",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.provinceCode
                                    ? scope.row.provinceCode +
                                        scope.row.cityCode +
                                        scope.row.regionCode
                                    : "--"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "消费金额",
                      "show-overflow": "",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.totalConsumeAmount
                                    ? scope.row.totalConsumeAmount.toFixed(2)
                                    : "0.00"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "assignTime",
                      field: "assignTime",
                      label: "分配时间",
                      "show-overflow": "",
                      "min-width": "200",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.extantMap,
                            function (item, index) {
                              return _c("p", { key: index }, [
                                _vm._v(_vm._s(item.assignTime || "-")),
                              ])
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerAssignTime",
                      field: "customerAssignTime",
                      label: "指派时间",
                      "show-overflow": "",
                      "min-width": "200",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.extantMap,
                            function (item, index) {
                              return _c("p", { key: index }, [
                                _vm._v(_vm._s(item.customerAssignTime || "-")),
                              ])
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "resourcesTimeList",
                      field: "resourcesTimeList",
                      label: "资源时间",
                      "show-overflow": "",
                      "min-width": "200",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.resourcesTimeList &&
                            scope.row.resourcesTimeList.length > 1
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "look",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onShowTime(
                                          scope.row.resourcesTimeList
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                )
                              : scope.row.resourcesTimeList &&
                                scope.row.resourcesTimeList.length == 1
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.resourcesTimeList[0] || "-"
                                    )
                                  ),
                                ])
                              : _c("p", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createdTime",
                      field: "createdTime",
                      label: "创建时间",
                      "show-overflow": "",
                      "min-width": "200",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("p", [_vm._v(_vm._s(scope.row.createdTime))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "updatedTime",
                      field: "updatedTime",
                      label: "最后更新时间",
                      "show-overflow": "",
                      "min-width": "200",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.is_null(scope.row.updatedTime)
                              ? _c("p", [_vm._v("--")])
                              : _c("p", [
                                  _vm._v(_vm._s(scope.row.updatedTime)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "230", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "添加订单",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("mcAddorder") != -1 &&
                                (scope.row.type == "3" ||
                                  scope.row.serviceId ||
                                  _vm.userId == 1)
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "operation",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toAddOrder(scope.row)
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("添单")])]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "转移客户",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("assageWy") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "operation",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showDialog(
                                              "分配资源",
                                              "assign",
                                              "70%",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("指派")])]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "编辑信息",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("btnEditCode") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "operation",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toInformation(scope.row)
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("查看/编辑")])]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "跟进",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "operation",
                                    on: {
                                      click: function ($event) {
                                        return _vm.followUpBtn(scope.row)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("跟进")])]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm.tableData.totalNum > 0
          ? _c("div", { staticClass: "page" }, [
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage1,
                      "page-sizes": [10, 20, 50, 100, 200],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.totalNum,
                      "prev-text": "上一页",
                      "next-text": "下一页",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            id: "show-el-dialog",
            visible: _vm.dialogBatch.visible,
            "append-to-body": true,
            title: _vm.dialogBatch.title,
            width: _vm.dialogBatch.width,
            "close-on-click-modal": false,
            "before-close": _vm.handledialogBatchClose,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogBatch, "visible", $event)
            },
          },
        },
        [
          _vm.dialogBatch.type == "batchAssign"
            ? [
                _c(
                  "div",
                  { staticStyle: { width: "250px" } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "ruleForm",
                        staticClass: "demo-ruleForm",
                        attrs: {
                          rules: _vm.rulesClientCategory,
                          model: _vm.ruleForm,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "类目", prop: "clientCategory" } },
                          [
                            _c("el-cascader", {
                              attrs: {
                                size: "mini",
                                clearable: "",
                                options: _vm.categoryOptions,
                                props: {
                                  label: "categoryName",
                                  value: "id",
                                  checkStrictly: true,
                                },
                                filterable: "",
                              },
                              on: { change: _vm.handleClientCategory },
                              model: {
                                value: _vm.ruleForm.clientCategory,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "clientCategory", $$v)
                                },
                                expression: "ruleForm.clientCategory",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      margin: "0px 20px",
                    },
                  },
                  [
                    _vm._v(" 员工姓名 "),
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请输入员工姓名", size: "small" },
                      model: {
                        value: _vm.formTc.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.formTc, "username", $$v)
                        },
                        expression: "formTc.username",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.treeAxios(1)
                      },
                    },
                  },
                  [_vm._v(" 搜索 ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "warning" },
                    on: {
                      click: function ($event) {
                        return _vm.treeAxios(2)
                      },
                    },
                  },
                  [_vm._v(" 重置 ")]
                ),
                _c(
                  "div",
                  { staticClass: "tree" },
                  [
                    _c("el-input", {
                      staticStyle: { margin: "0 0px 20px" },
                      attrs: { placeholder: "输入关键字进行搜索" },
                      model: {
                        value: _vm.filterText,
                        callback: function ($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText",
                      },
                    }),
                    _c("el-tree", {
                      ref: "tree",
                      staticClass: "el-menu-vertical-demo",
                      attrs: {
                        data: _vm.tree,
                        props: _vm.defaultProps,
                        "highlight-current": true,
                        "default-expand-all": true,
                        "filter-node-method": _vm.filterNode,
                      },
                      on: { "node-click": _vm.handleNodeClick },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "table1" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.tablePerson.list,
                          "row-key": _vm.getRowKey,
                        },
                        on: {
                          "selection-change": _vm.handleSelectionMoreChange,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "50",
                            "reserve-selection": true,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "姓名" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("p", [
                                      _vm._v(_vm._s(props.row.reallyName)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            220011154
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "联系电话", prop: "phoneNumber" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "所在部门" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(props.row.orgName)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            876307707
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "职位", prop: "positionName" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "员工状态", prop: "statusName" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.tablePerson.totalNum > 0
                  ? _c("div", { staticClass: "page2" }, [
                      _c(
                        "div",
                        { staticClass: "block" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.stafpage,
                              "page-size": _vm.stafPageSize,
                              layout: "total,sizes,prev, pager, next",
                              "prev-text": "上一页",
                              "next-text": "下一页",
                              total: _vm.tablePerson.totalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeEmplay,
                              "current-change": _vm.handleCurrentEmplay,
                              "update:currentPage": function ($event) {
                                _vm.stafpage = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.stafpage = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            _vm.listAxios()
                            _vm.dialogBatch.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submission("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            id: "show-el-dialog",
            visible: _vm.dialog.visible,
            "append-to-body": true,
            title: _vm.dialog.title,
            width: _vm.dialog.width,
            "close-on-click-modal": false,
            "before-close": _vm.handledialogService,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "assign"
            ? [
                _c(
                  "div",
                  { staticStyle: { width: "250px" } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "ruleForm",
                        staticClass: "demo-ruleForm",
                        attrs: {
                          rules: _vm.rulesClientCategory,
                          model: _vm.ruleForm,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "类目", prop: "clientCategory" } },
                          [
                            _c("el-cascader", {
                              attrs: {
                                size: "mini",
                                clearable: "",
                                options: _vm.categoryOptions,
                                props: {
                                  label: "categoryName",
                                  value: "id",
                                  checkStrictly: true,
                                },
                                filterable: "",
                              },
                              on: { change: _vm.handleClientCategory },
                              model: {
                                value: _vm.ruleForm.clientCategory,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "clientCategory", $$v)
                                },
                                expression: "ruleForm.clientCategory",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      margin: "0px 20px",
                    },
                  },
                  [
                    _vm._v(" 员工姓名 "),
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请输入员工姓名", size: "small" },
                      model: {
                        value: _vm.formTc.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.formTc, "username", $$v)
                        },
                        expression: "formTc.username",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.treeAxios(1)
                      },
                    },
                  },
                  [_vm._v(" 搜索 ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "warning" },
                    on: {
                      click: function ($event) {
                        return _vm.treeAxios(2)
                      },
                    },
                  },
                  [_vm._v(" 重置 ")]
                ),
                _c(
                  "div",
                  { staticClass: "tree" },
                  [
                    _c("el-input", {
                      staticStyle: { margin: "0 0px 20px" },
                      attrs: { placeholder: "输入关键字进行搜索" },
                      model: {
                        value: _vm.filterText,
                        callback: function ($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText",
                      },
                    }),
                    _c("el-tree", {
                      ref: "tree",
                      staticClass: "el-menu-vertical-demo",
                      attrs: {
                        data: _vm.tree,
                        props: _vm.defaultProps,
                        "highlight-current": true,
                        "default-expand-all": true,
                        "filter-node-method": _vm.filterNode,
                      },
                      on: { "node-click": _vm.handleNodeClick },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "table1" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTableTWO",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.tablePerson.list,
                          "row-key": _vm.getRowKey,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { width: "50" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { color: "#fff" },
                                        attrs: { label: scope.$index },
                                        nativeOn: {
                                          change: function ($event) {
                                            return _vm.getCurrentRow(scope.row)
                                          },
                                        },
                                        model: {
                                          value: _vm.multipleSelection,
                                          callback: function ($$v) {
                                            _vm.multipleSelection = $$v
                                          },
                                          expression: "multipleSelection",
                                        },
                                      },
                                      [_c("span", [_vm._v(" ")])]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            47093805
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "姓名" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("p", [
                                      _vm._v(_vm._s(props.row.reallyName)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            220011154
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "联系电话", prop: "phoneNumber" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "所在部门" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(props.row.orgName)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            876307707
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "职位", prop: "positionName" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "员工状态", prop: "statusName" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.tablePerson.totalNum > 0
                  ? _c("div", { staticClass: "page2" }, [
                      _c(
                        "div",
                        { staticClass: "block" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.stafpage,
                              "page-size": _vm.stafPageSize,
                              layout: "total,sizes,prev, pager, next",
                              "prev-text": "上一页",
                              "next-text": "下一页",
                              total: _vm.tablePerson.totalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeEmplay,
                              "current-change": _vm.handleCurrentEmplay,
                              "update:currentPage": function ($event) {
                                _vm.stafpage = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.stafpage = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            _vm.listAxios()
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.allocation("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "queryService"
            ? [
                _c(
                  "el-form",
                  {
                    staticClass: "search-form",
                    attrs: {
                      inline: true,
                      model: _vm.queryForm,
                      size: "small",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户电话" } },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入客户手机号码",
                            oninput:
                              "if (value.length > 16) value = value.slice(0, 16);",
                          },
                          model: {
                            value: _vm.clientPhone,
                            callback: function ($$v) {
                              _vm.clientPhone =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "clientPhone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信号" } },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入客户微信号",
                            maxlength: "20",
                          },
                          model: {
                            value: _vm.clientWechat,
                            callback: function ($$v) {
                              _vm.clientWechat =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "clientWechat",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "68px", height: "32px" },
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handlerClient()
                          },
                        },
                      },
                      [_vm._v(" 搜索 ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.clientMessage,
                      "row-key": _vm.getRowKey,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "客户姓名",
                        minWidth: "40",
                        prop: "userName",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "客户电话",
                        minWidth: "60",
                        prop: "phone",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "客户电话2",
                        minWidth: "60",
                        prop: "phone2",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "微信号",
                        minWidth: "60",
                        prop: "wechatNo",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "微信号2",
                        minWidth: "60",
                        prop: "wechatNo2",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "所属公司部门", minWidth: "80" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      props.row.orgNames
                                        ? props.row.orgNames
                                        : "-"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        311366634
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "跟进客服",
                        minWidth: "50",
                        prop: "reallyName",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "跟进时间",
                        minWidth: "80",
                        prop: "assignTime",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "创建时间",
                        minWidth: "80",
                        prop: "createdTime",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "add"
            ? [
                _c("add-customers", {
                  ref: "addCustomers",
                  attrs: { type: _vm.dialog.type, getDateList: _vm.listAxios },
                  on: { closeDialog: _vm.closeDialog },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "新增跟进记录",
            visible: _vm.drawer,
            direction: _vm.direction,
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "followUp",
              attrs: { model: _vm.followUp, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "跟进人:",
                    prop: "customerName",
                    "label-width": "110px",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.followUp.customerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.followUp, "customerName", $$v)
                      },
                      expression: "followUp.customerName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "类目:",
                    prop: "customerName",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.followUp.categoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "categoryId", $$v)
                        },
                        expression: "followUp.categoryId",
                      },
                    },
                    _vm._l(_vm.followCustomerArr, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "秒杀:",
                    prop: "spiked",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.seckill },
                      model: {
                        value: _vm.followUp.spiked,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "spiked", $$v)
                        },
                        expression: "followUp.spiked",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("无")]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("秒杀"),
                      ]),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticStyle: { width: "20%", "margin-left": "20px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      type: "number",
                      disabled: _vm.seckillPrice,
                      size: "mini",
                    },
                    model: {
                      value: _vm.followUp.spikeMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.followUp, "spikeMoney", $$v)
                      },
                      expression: "followUp.spikeMoney",
                    },
                  }),
                  _c("span", { staticStyle: { "padding-left": "5px" } }, [
                    _vm._v("元"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "接听状态:",
                    prop: "receiveState",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.answerStatus },
                      model: {
                        value: _vm.followUp.receiveState,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "receiveState", $$v)
                        },
                        expression: "followUp.receiveState",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("无")]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("接通"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("未接通"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "接听状况:",
                    prop: _vm.receiveDetailsState,
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择接听状况",
                        clearable: "",
                        disabled: _vm.answerState,
                        "default-first-option": true,
                      },
                      model: {
                        value: _vm.followUp.receiveDetails,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "receiveDetails", $$v)
                        },
                        expression: "followUp.receiveDetails",
                      },
                    },
                    _vm._l(_vm.answerStateDate.list, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              !_vm.followUpDateList.wechatNo
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "微信添加状态:",
                        prop: "wxFencing",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.wxAddState },
                          model: {
                            value: _vm.followUp.wxFencing,
                            callback: function ($$v) {
                              _vm.$set(_vm.followUp, "wxFencing", $$v)
                            },
                            expression: "followUp.wxFencing",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("已添加"),
                          ]),
                          _c("el-radio", { attrs: { label: "4" } }, [
                            _vm._v("未添加"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.followUp.wxFencing === "3" || _vm.followUpDateList.wechatNo
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "客户微信号",
                        "label-width": "110px",
                        prop: "wechatNo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: 20,
                          oninput:
                            "if (value.length > 20) value = value.slice(0, 20);",
                        },
                        model: {
                          value: _vm.followUp.wechatNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.followUp, "wechatNo", $$v)
                          },
                          expression: "followUp.wechatNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.followUp.wxFencing === "3" || _vm.followUpDateList.wechatNo
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客户微信号2", "label-width": "110px" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: 20,
                          oninput:
                            "if (value.length > 20) value = value.slice(0, 20);",
                        },
                        model: {
                          value: _vm.followUp.wechatNo2,
                          callback: function ($$v) {
                            _vm.$set(_vm.followUp, "wechatNo2", $$v)
                          },
                          expression: "followUp.wechatNo2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.followUp.wxFencing === "3"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "跟进客服微信号",
                        prop: "serviceWechatNo",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c("el-autocomplete", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "fetch-suggestions": _vm.queryWorkWechat,
                          "trigger-on-focus": true,
                          placeholder: "请输入或选择工作微信号",
                          "value-key": "wechatAccount",
                          clearable: "",
                          "popper-class": "autocomplete-popper",
                        },
                        on: { select: _vm.handleSelectWorkWechat },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ item }) {
                                return [
                                  _c("div", { staticClass: "wechat-option" }, [
                                    _c(
                                      "span",
                                      { staticClass: "wechat-account" },
                                      [_vm._v(_vm._s(item.wechatAccount))]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1829335399
                        ),
                        model: {
                          value: _vm.followUp.serviceWechatNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.followUp, "serviceWechatNo", $$v)
                          },
                          expression: "followUp.serviceWechatNo",
                        },
                      }),
                      _vm.wechatTipsVisible && _vm.filteredWechatList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "wechat-tips" },
                            _vm._l(
                              _vm.filteredWechatList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "wechat-tip-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectWechatTip(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "wechat-account" },
                                      [_vm._v(_vm._s(item.wechatAccount))]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "微信状况:",
                    prop: "wxDetails",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择微信状况",
                        clearable: "",
                        "default-first-option": true,
                      },
                      model: {
                        value: _vm.followUp.wxDetails,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "wxDetails", $$v)
                        },
                        expression: "followUp.wxDetails",
                      },
                    },
                    _vm._l(_vm.wxAddStateData.list, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", "label-width": "110px" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.followUp.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.followUp, "comment", $$v)
                      },
                      expression: "followUp.comment",
                    },
                  }),
                ],
                1
              ),
              _c("div", [
                _vm.parArray.indexOf("template_send") != -1
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "titleCss" }, [
                          _vm._v(" 发送短信 "),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "发送短信:",
                              "label-width": "110px",
                              prop: "sendMessageFlag",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: { change: _vm.handlerSendRadio },
                                model: {
                                  value: _vm.followUp.sendMessageFlag,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.followUp,
                                      "sendMessageFlag",
                                      $$v
                                    )
                                  },
                                  expression: "followUp.sendMessageFlag",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("否"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("是"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.followUp.sendMessageFlag == "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "模板:",
                                  prop: _vm.templateIdProp,
                                  "label-width": "110px",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择模板",
                                    },
                                    on: { change: _vm.selectTemplate },
                                    model: {
                                      value: _vm.followUp.templateId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.followUp,
                                          "templateId",
                                          $$v
                                        )
                                      },
                                      expression: "followUp.templateId",
                                    },
                                  },
                                  _vm._l(_vm.templateOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm.templateCenter
                                  ? _c("div", { staticClass: "templateDiv" }, [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.templateCenter)),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.followUp.paramList.length != 0 &&
                        _vm.followUp.sendMessageFlag == "1"
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.customerMessage,
                                function (item, index) {
                                  return _c(
                                    "el-form-item",
                                    {
                                      key: index,
                                      attrs: {
                                        "label-width": "110px",
                                        label: "参数",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            " 参数" + _vm._s(index + 1) + "： "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-radio-group",
                                        {
                                          on: {
                                            change: function ($event) {
                                              return _vm.messageModel(
                                                index,
                                                _vm.followUp.paramList[index]
                                                  .paramType
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.followUp.paramList[index]
                                                .paramType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.followUp.paramList[index],
                                                "paramType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "followUp.paramList[index].paramType",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "1" } },
                                            [_vm._v("客户信息")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "2" } },
                                            [_vm._v("自定义信息")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.followUp.paramList[index].paramType ==
                                      "2"
                                        ? _c("el-input", {
                                            ref: "saveTagInput",
                                            refInFor: true,
                                            staticClass: "input-new-tag",
                                            attrs: {
                                              placeholder: "请输入客户信息",
                                            },
                                            model: {
                                              value:
                                                _vm.followUp.paramList[index]
                                                  .paramContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.followUp.paramList[index],
                                                  "paramContent",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "followUp.paramList[index].paramContent",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.followUp.paramList[index].paramType ==
                                      "1"
                                        ? _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请选择客户信息",
                                              },
                                              model: {
                                                value:
                                                  _vm.followUp.paramList[index]
                                                    .paramContent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.followUp.paramList[
                                                      index
                                                    ],
                                                    "paramContent",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "followUp.paramList[index].paramContent",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dictionaries
                                                .message_customer_user_info,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.dictName,
                                                    value: item.dictId,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _vm.followUp.sendMessageFlag == "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "模板签名:",
                                  prop: _vm.signNameProp,
                                  "label-width": "110px",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择模板签名",
                                    },
                                    model: {
                                      value: _vm.followUp.signName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.followUp, "signName", $$v)
                                      },
                                      expression: "followUp.signName",
                                    },
                                  },
                                  _vm._l(
                                    _vm.dictionaries.message_sign_type,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.dictName,
                                          value: item.dictId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", "label-width": "110px" } },
                          [
                            _vm.followUp.sendMessageFlag == "1"
                              ? _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      "false-label": 0,
                                      "true-label": 1,
                                    },
                                    on: { change: _vm.handlerCheckbox },
                                    model: {
                                      value: _vm.followUp.defFlag,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.followUp, "defFlag", $$v)
                                      },
                                      expression: "followUp.defFlag",
                                    },
                                  },
                                  [_vm._v("设为默认 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.parArray.indexOf("historyList") != -1
                  ? _c("div", { staticClass: "titleCss" }, [
                      _vm._v(" 跟进记录 "),
                    ])
                  : _vm._e(),
                _vm.parArray.indexOf("historyList") != -1
                  ? _c(
                      "div",
                      { staticClass: "followUp" },
                      _vm._l(_vm.customerData, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "followUpBox" },
                          [
                            _c("p", [
                              _c("span", [
                                _vm._v("跟进人："),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.customerName
                                        ? item.customerName
                                        : "-"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("p", [
                              _c("span", [
                                _vm._v("所属公司部门："),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.companyName ? item.companyName : "-"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("p", [
                              _c("span", [
                                _vm._v("跟进情况："),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.comment ? item.comment : "-")
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("p", [
                              _c("span", [
                                _vm._v("跟进类型："),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.receiveState == 0
                                        ? "无"
                                        : item.receiveState
                                    )
                                  ),
                                ]),
                                _vm._v("/"),
                                _c("span", [
                                  _vm._v("微信" + _vm._s(item.wxFencing)),
                                ]),
                              ]),
                            ]),
                            _c("p", [
                              _c("span", [
                                _vm._v("操作时间："),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.createdTime ? item.createdTime : "-"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("span", { staticClass: "followUpBox_index" }, [
                              _vm._v(_vm._s(item.numIndex)),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "drawerBtn" },
                [
                  _c(
                    "el-button",
                    { staticClass: "cancel", on: { click: _vm.handlerQuxiao } },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "affirm",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.subFollowUp("followUp")
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("popAddOrderTips", {
        ref: "popAddOrderTips",
        on: { toAddOrderLink: _vm.toAddOrderLink },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "资源时间",
            visible: _vm.showTime,
            top: _vm.popTop,
            "append-to-body": true,
            width: "300px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTime = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "time-list" },
            _vm._l(_vm.showTimeList, function (item, index) {
              return _c("div", { staticClass: "item-time" }, [
                _c("span", { staticClass: "no" }, [_vm._v(_vm._s(+index + 1))]),
                _c("span", { staticClass: "time" }, [_vm._v(_vm._s(item))]),
              ])
            }),
            0
          ),
        ]
      ),
      _c("pop-import", { ref: "popImport" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title_left" }),
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "18px",
              "font-family": "PingFang SC",
              "font-weight": "bold",
              "line-height": "25px",
              color: "#333333",
              padding: "15px 0 15px 0",
            },
          },
          [_vm._v("我的客户")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", { staticStyle: { "font-size": "18px" } }, [
        _vm._v("数据筛选"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }